import axios from 'axios';

export const apiUrl = process.env.REACT_APP_API_URL
export const serverIP = process.env.REACT_APP_SERVER
export let images = []

const fetchCategoryList = async () => {
    try {
        const response = await axios.get(apiUrl + '/categoryList');
        const responseData = response.data;
        const options = responseData.map(item => ({
            value: item.categotyId,
            label: item.categotyName,
            // imageData: item.imageData
        }));
        images = responseData.map(item => ({
            value: item.categotyId,
            label: item.categotyName,
            imageData: item.imageData,
            urlType: item.urlType
        }));
        return options;
    } catch (error) {
        console.error('Error fetching category list:', error);
        return [];
    }
};
export const options = await fetchCategoryList();

export const AND = "a1N1d";
export const OR = "o2N2r";
export const NOT = "n3O3t";